import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=f946a2ac&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import "./Pagination.vue?vue&type=style&index=0&id=f946a2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f946a2ac",
  null
  
)

export default component.exports